import GenWhoShouldSection from '@app-ila/components/Card/GenWhoShouldSection';
import SectionTitle from '@app-ila/components/Text/SectionTitle';
import { Box, Flex } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/**
 *
 * @param {Object} sectionContent
 * @returns
 */
const GenWhoShouldAttend = ({ sectionContent }) => {
  return (
    <Box
      maxW={{
        base: '100%',
        sm: '540px',
        md: '720px',
        lg: '960px',
        xl: '1082px',
      }}
      //mx="auto"
      w="100%"
      py={{ base: '30px', md: '0', xl: '30px' }}
      m={"auto"}
    >
      <Box
        maxW="600px"
        pb={{ base: '20px', md: '30px', xl: '0' }}
        pl={{base:"30px", sm:"30px", md:"20px", xl:"0px"}}
      >
        <SectionTitle 
        titleObj={sectionContent[0]}
        fontSize={{base:"40px", md:"46px"}}
       />
      </Box>
      <Flex
        px={{ base: '30px', md: '0' }}
        flexWrap="wrap"
        justifyContent="space-between"
        maxW={{ base: '100%', md: '100%', xl: '100%' }}
        gap={{base:"20px", sm:"20px", md:"10px"}}
      >
        {sectionContent[1].cards.map((card, index) => {
          return (
            <GenWhoShouldSection
              w="100%"
              card={card}
              p={"20px"}
              paddingBottom={{ base: '5px', md: '10px' }}
              background={"#17175F"}
              maxW={{ base: '100%', md: '30%', xl: '250px' }}
              key={nanoid()}
              flexDir="column"
              mergeBottom={'15px'}
              mx={"auto"}
            />
          );
        })}
      </Flex>
    </Box>
  );
};

export default GenWhoShouldAttend;
